import performanceImage from './assets/todays-performance.png';
import styles from './PerformancePreview.module.css';

export function PerformancePreview({ className, testId }: { className?: string; testId?: string }) {
  return (
    <figure className={[styles.preview, className].filter(Boolean).join(' ')} data-testid={testId}>
      <img
        src={performanceImage}
        width={658}
        height={597}
        fetchPriority="high"
        decoding="async"
        alt="Today's Performance: 20 purchases at $36.83 per purchase, 56% below the 90-day average of $83.01, with a daily cost comparison chart."
      />
      <figcaption>Example performance view</figcaption>
    </figure>
  );
}
